import React, { useState } from "react";
import PanelTemplate from "../../shares/PanelTemplate";
import AdminReturnedOrderListByBangle from "./AdminReturnedOrderListByBangle";
import AdminReturnedOrderListByCustomer from "./by_customer/AdminReturnedOrderListByCustomer";

const AdminReturnedOrderList = () => {
  const [activeTab, setActiveTab] = useState("1");
  return (
    <>
      <PanelTemplate sidebarActiveLink="returned-order-list">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های مرجوعی</span>
          </div>
          <div className="mt-8 flex items-center">
            <span
              className={activeTab == "1" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("1")}
            >
              براساس مشتری
            </span>
            {/* <span
              className={activeTab == "2" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("2")}
            >
              براساس النگو
            </span> */}
          </div>
          <div
            style={{ backgroundColor: "#fefcfb" }}
            className="border rounded-b-md rounded-tl-md px-2 py-6 mb-4"
          >
            {activeTab == "1" ? (
              <AdminReturnedOrderListByCustomer />
            ) : (
              // <AdminReturnedOrderListByBangle />
              <></>
            )}
          </div>
        </>
      </PanelTemplate>
    </>
  );
};

export default AdminReturnedOrderList;
